import { Heading, Text, VFlow } from 'bold-ui'
import { PageLoading } from 'components/loading'
import {
  useDispositivosPareadosUnidadeSaudeQuery,
  usePermissaoPainelChamadasQuery,
  useSalasUnidadeSaudeQuery,
} from 'graphql/hooks.generated'
import { emptyArrayOf } from 'util/array'

import { DispositivoPainelChamadaRow, PermissaoPainelChamadas, SalaPainelChamadaRow } from '../model-chamadaPainel'
import { CadastrarDispositivoPainelChamadasBox } from './components/CadastrarDispositivoPainelChamadasBox'
import { CadastrarSalaPainelChamadasBox } from './components/CadastrarSalaPainelChamadasBox'
import { HabilitarPainelChamadasBox } from './components/HabilitarPainelChamadasBox'

interface ConfiguracaoPainelChamadasViewProps {
  unidadeSaudeId: ID
}

export const ConfiguracaoPainelChamadasView = (props: ConfiguracaoPainelChamadasViewProps) => {
  const { unidadeSaudeId } = props

  const {
    data: dataDispositivosPareados,
    loading: loadingDispositivosPareados,
    refetch: refetchDispositivosPareados,
  } = useDispositivosPareadosUnidadeSaudeQuery({
    variables: { unidadeSaudeId },
  })

  const { data: dataSalas, loading: loadingSalas, refetch: refetchSalasUnidadeSaude } = useSalasUnidadeSaudeQuery({
    variables: { unidadeSaudeId },
  })

  const { data: dataPermissao, loading: loadingPermissao } = usePermissaoPainelChamadasQuery({
    variables: { unidadeSaudeId },
  })

  const isButtonHabilitarDisabled =
    (dataSalas?.salasUnidadeSaude?.isEmpty() ||
      dataDispositivosPareados?.dispositivosPareadosUnidadeSaude?.isEmpty()) ??
    true

  const permissaoGql = dataPermissao?.unidadeSaude?.actions?.permissaoPainelChamadas
  const permissao: PermissaoPainelChamadas = {
    enabled: permissaoGql?.enabled ?? false,
    hint: permissaoGql?.hint ?? null,
  }

  if (loadingPermissao) {
    return <PageLoading message='Carregando...' />
  }

  return (
    <VFlow vSpacing={0.5}>
      <Heading level={2}>Configurar painel de chamadas da unidade</Heading>
      <Text>
        O painel de chamadas da unidade de saúde irá permitir que os cidadãos sejam chamados para atendimento através de
        uma ação na lista de atendimentos. Para utilizar o painel de chamadas na sua unidade, é necessário configurar
        pelo menos um dispositivo para apresentar o painel e as salas que os profissionais devem selecionar no momento
        de chamar o cidadão.
      </Text>
      <Heading level={2}>Passo 1 - Cadastrar salas</Heading>
      <CadastrarSalaPainelChamadasBox
        salas={dataSalas?.salasUnidadeSaude ?? emptyArrayOf<SalaPainelChamadaRow>()}
        loadingSalas={loadingSalas}
        unidadeSaudeId={unidadeSaudeId}
        onCreate={refetchSalasUnidadeSaude}
        onDelete={refetchSalasUnidadeSaude}
        permissao={permissao}
      />
      <Heading level={2}>Passo 2 - Vincular dispositivos</Heading>
      <CadastrarDispositivoPainelChamadasBox
        dispositivosPareados={
          dataDispositivosPareados?.dispositivosPareadosUnidadeSaude ?? emptyArrayOf<DispositivoPainelChamadaRow>()
        }
        loadingDispositivosPareados={loadingDispositivosPareados}
        unidadeSaudeId={unidadeSaudeId}
        onCreate={refetchDispositivosPareados}
        onDelete={refetchDispositivosPareados}
        permissao={permissao}
      />
      <Heading level={2}>Passo 3 - Habilitar painel de chamadas</Heading>
      <HabilitarPainelChamadasBox
        unidadeSaudeId={unidadeSaudeId}
        isButtonDisabled={isButtonHabilitarDisabled}
        permissao={permissao}
      />
    </VFlow>
  )
}
